import { IMarket } from 'interfaces/IMarket';
import { IUser } from 'interfaces/IUser';
import { PropertyTypeNames } from 'constants/propertyTypes';
import { FindCompsSearchTab } from 'constants/findCompTabs';

export const getDefaultPreferencesFilter = (
  markets: IMarket[],
  user: IUser,
) => {
  const { marketIds = [], propertyTypes = [] } = user?.preferences ?? {};

  return {
    markets:
      markets
        ?.filter(m => marketIds.includes(m.id))
        .map(({ id, name }) => ({ id, name })) ?? [],
    propertyTypes:
      propertyTypes.map(id => ({ id, name: PropertyTypeNames[id] })) ?? [],
  };
};

export const getUserPreferredCustomCriteria = (
  user: IUser,
  currentSearchTab: FindCompsSearchTab,
) => {
  const preferences = user?.preferences ?? {};
  const { propertyTypes, marketIds } = preferences;

  return {
    ...(currentSearchTab === FindCompsSearchTab.MARKET_SEARCH && {
      markets: marketIds?.map(m => ({ id: m })),
    }),
    propertyTypes: propertyTypes?.map(p => ({ id: p })),
    types: propertyTypes?.map(p => ({ id: p })),
  };
};
